import { css } from 'styled-components';

export const scrollbarStyle = css`
  overflow-y: auto;
  scrollbar-gutter: auto;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    opacity: 0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: var(--buttonBorderRadius);
    border-radius: 5px !important;
    background-clip: content-box !important;
    opacity: 0;
    transform: scaleX(0.8);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  /* 호버 시 부드러운 나타남 애니메이션 */
  &:hover::-webkit-scrollbar-track {
    background-color: var(--cardBackgroundColor);
    opacity: 1;
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: var(--subColor);
    opacity: 1;
    transform: scaleX(1);
  }

  /* 포커스 시에도 동일한 애니메이션 */
  &:focus-within::-webkit-scrollbar-track {
    background-color: var(--cardBackgroundColor);
    opacity: 1;
  }

  &:focus-within::-webkit-scrollbar-thumb {
    background-color: var(--subColor);
    opacity: 1;
    transform: scaleX(1);
  }

  /* 스크롤바 드래그 시 더 진한 색상과 약간 확대 */
  &::-webkit-scrollbar-thumb:active {
    background-color: var(--primaryColor) !important;
    transform: scaleX(1.1) !important;
    transition: all 0.1s ease !important;
  }
`;

/* 🆕 더욱 고급 애니메이션이 적용된 버전 */
export const scrollbarAutoShow = css`
  overflow-y: auto;
  scrollbar-gutter: auto;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    opacity: 0;
    transform: translateX(2px);
    transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 5px;
    opacity: 0;
    transform: scaleX(0.6) translateX(2px);
    transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  /* 호버 시 슬라이드인 + 페이드인 애니메이션 */
  &:hover::-webkit-scrollbar-track {
    background-color: rgba(var(--cardBackgroundColorRGB, 255, 255, 255), 0.1);
    opacity: 1;
    transform: translateX(0);
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: rgba(var(--subColorRGB, 128, 128, 128), 0.6);
    opacity: 1;
    transform: scaleX(1) translateX(0);
  }

  /* 드래그 시 펄스 효과 */
  &::-webkit-scrollbar-thumb:active {
    background-color: var(--subColor) !important;
    transform: scaleX(1.2) translateX(0) !important;
    box-shadow: 0 0 8px rgba(var(--subColorRGB, 128, 128, 128), 0.3) !important;
    transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55) !important;
  }

  /* Firefox 지원 (애니메이션 제한적) */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  transition: scrollbar-color 0.3s ease;

  &:hover {
    scrollbar-color: rgba(128, 128, 128, 0.6) rgba(255, 255, 255, 0.1);
  }
`;

/* 🆕 미니멀한 페이드 애니메이션 버전 */
export const scrollbarFadeShow = css`
  overflow-y: auto;
  scrollbar-gutter: auto;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--subColor);
    border-radius: 4px;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  /* 심플한 페이드 인/아웃 */
  &:hover::-webkit-scrollbar-track,
  &:focus-within::-webkit-scrollbar-track {
    opacity: 0.3;
  }

  &:hover::-webkit-scrollbar-thumb,
  &:focus-within::-webkit-scrollbar-thumb {
    opacity: 0.7;
  }

  &::-webkit-scrollbar-thumb:hover {
    opacity: 1 !important;
  }
`;

export const scrollbarHide = css`
  // hide scrollbar but is working
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
  // IE and Edge
  -ms-overflow-style: none;
  // Firefox
  scrollbar-width: none;
`;